import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

// Debe coincidir con el $limit de departamentos/selectDepartamentosItem
const DEPARTAMENTOS_POR_PAGINA = 30;

class SelectDepartamentosItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
      texto: '',
      hayMas: true,
    };
    // El scroll dispara muy seguido, no basta con state.cargando (se actualiza async)
    this.peticionEnCurso = false;

    this.buscarDepartamentos = debounce(this.buscarDepartamentos.bind(this), 300);
  }

  componentDidMount() {
    // Cargar los primeros 10 al abrir por primera vez
    this.buscarDepartamentos('');
  }

  componentDidUpdate(prevProps) {
    if(prevProps.value !== this.props.value) {
      // Si el valor cambia, solo se recarga cuando falta el nombre de algun seleccionado.
      // Recargar siempre reiniciaba la lista a la primera pagina y tiraba el scroll ya cargado.
      if(this.props.value){
        const valores = Array.isArray(this.props.value) ? this.props.value : [this.props.value];
        const faltantes = valores.filter((valor) => valor &&
          !this.state.opciones.some((departamento) => departamento._id.toString() === valor.toString()));
        if (faltantes.length === 1 && !Array.isArray(this.props.value)) {
          this.buscarDepartamentos(faltantes[0].toString());
        } else if (faltantes.length > 0) {
          this.buscarDepartamentos('');
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.buscarDepartamentos && this.buscarDepartamentos.cancel) {
      this.buscarDepartamentos.cancel();
    }
  }

  async buscarDepartamentos(texto, append = false) {
    // El value puede ser un arreglo (mode multiple), no sirve como texto de busqueda
    const textoBusqueda = typeof texto === 'string' ? texto : '';

    // Al llegar al fondo no se encadenan peticiones ni se piden paginas que ya no existen
    if (append && (this.peticionEnCurso || !this.state.hayMas)) return;

    this.peticionEnCurso = true;
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "departamentos/selectDepartamentosItem",
        {
          empresaId: this.props.empresaId,
          query: append ? this.state.texto : textoBusqueda,
          values: this.props.value,
          skip: append ? this.state.opciones.length : 0, // saltar los ya cargados
        },
        {
          headers: this.props.headersToken,
        }
      );

      if (res.data.success === 2) {
        const departamentos = res.data.departamentos || [];
        this.setState({
          opciones: append ? [...this.state.opciones, ...departamentos] : departamentos,
          primerCarga: true,
          texto: append ? this.state.texto : textoBusqueda,
          hayMas: departamentos.length >= DEPARTAMENTOS_POR_PAGINA,
        });
      } else {
        // Si falla una pagina del scroll no se pierde lo que ya estaba cargado
        this.setState({
          opciones: append ? this.state.opciones : [],
          primerCarga: true,
          texto: append ? this.state.texto : textoBusqueda,
          hayMas: false,
        });
      }
    } catch (error) {
      console.error("Error al buscar departamentos:", error);
      this.setState({
        opciones: append ? this.state.opciones : [],
        texto: append ? this.state.texto : textoBusqueda,
        hayMas: false,
      });
    } finally {
      // Asegurar que siempre se quite el loading
      this.peticionEnCurso = false;
      this.setState({ cargando: false });
    }
  }


  render() {
    const {
      noBuscar,
      mode,
      selectAll,
      mostrarCarga,
      onSelectAll,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      mode: mode,
      onSearch: this.buscarDepartamentos,
      // Mostrar loading cuando está cargando, o mensaje cuando no hay resultados
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: 'center', padding: '8px' }}>
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
            Buscando departamentos...
          </div>
        </div>
      ) : this.state.primerCarga ? 'No se encontraron departamentos' : null,
      // Mostrar loading en el input del select
      loading: this.state.cargando,
    };

    if (mode === 'multiple') {
      propsNuevas.maxTagCount = 'responsive';
    }

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? (fondoBlanco ? 'white' : 'white') : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };


    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={400}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>
            {menu}
          </Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const departamento = this.state.opciones.find((departamento) => departamento._id === value);
          this.props.onChange(value, departamento)
        }}
        placeholder={this.state.cargando && !this.state.primerCarga ? "Cargando..." : placeholder}
        style={estiloFinal}
        bordered={false}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 4) {
            // Llegaste al fondo -> cargar mas
            this.buscarDepartamentos(this.state.texto, true);
          }
        }}
      >
        {this.state.opciones.map((departamento) => (
          <Option key={departamento._id} value={departamento._id}>
            {departamento.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectDepartamentosItem;